import React, { useRef, useState } from 'react';
import { useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { getTemplateFileName } from '../../../../services/multipleElectronicSignature';
import ModalComponent from '../../../helper_components/ModalComponent';
import useElectronicSignatureTemplatesModal from '../customHooks/useElectronicSignatureTemplatesModal';
import NotifyEmailModal from './NotifyEmailModal';
import CredentialsModal from '../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/credentialsModal/CredentialsModal';
import ToggleButton from '../../../layout/shared/ToggleButton';
import ElectronicSignatureTable from '../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/componets/ElectronicSignatureTable';
import { useElectronicSignatureProcessContext } from '../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/context/ElectronicSignatureProcessContext';
import { useTemplatesPresavedContextContext } from '../context/templatesPresavedContext';
import { electronicSignatureSettingsFirel } from '../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/constants/electronicSignatureSettingsFirel';
import SimpleSignatureAlert from './SimpleSignatureAlert';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import { secondCustomHeaderDatePicker } from '../expedient_details_logic';
import { holidayDates, isWeekday } from '../components/CustomInputDate/CustomDateRules';
import CustomInputDate from '../components/CustomInputDate/CustomInputDate';
import moment from 'moment';
import { renderErrorsList } from '../../../edit_profile/edit_profile_logic';
import { is } from 'date-fns/locale';
registerLocale('es', es);
const ElectronicSignatureTemplatesModal = ({
  htmlOfDocumentToSign,
  expedientTemplateId,
  templateName,
  ExpedientId,
  userId,
  templateData,
  setTemplateData,
  reloadExpedientDetailsComponent,
  setReloadTemplatesData,
  onCloseTemplateModal,
  electronicNotificationState,
  setShowModalTiny,
  dataExpedient,
  emailTemplateId,
  setDocumentToAssign,
  setIsUsersAndPermissionsListModalShowing,
  transferState = {},
}) => {
  const firstInputDatePicker = useRef(null);
  const [datePickerIsEnabled, setDatePickerIsEnabled] = useState(false);
  const [dateIsAccepted, setDateIsAccepted] = useState(true);
  const [errors, setErrors] = useState({});
  const [holiday, setHoliday] = useState([]);

  const {
    isElectronicSignatureModalSowing,
    setIsElectronicSignatureModalSowing,
    electronicSignaturesList,
    onCloseModal: onCloseCredentialsModal,
    onAddElectronicSignature,
    isMultipleSignature,
    onDelteElectronicSignatureById,
    singleElectronicSignature,
    isThereASignature,
  } = useElectronicSignatureProcessContext();

  const { isElectronicSignatureModalOpen, onCloseElectronicSignatureModal } =
    useTemplatesPresavedContextContext();

  const documentToSignName = useMemo(
    () => getTemplateFileName(templateName, expedientTemplateId, ExpedientId),
    [templateName, expedientTemplateId, ExpedientId]
  );

  const {
    onSingTemplate,
    isNotificationModalShowing,
    onCloseNotifyEmailModal,
    isMultisignatureEnabled,
    isElectronicSignatureTableShowing,
    onToggleButtonClick,
    isSimpleSignatureAlertShowing,
    setIsSimpleSignatureAlertShowing,
    onCancelSimpleSignatureAlertClick,
    onContinueSimpleSignatureAlertClick,
  } = useElectronicSignatureTemplatesModal({
    htmlOfDocumentToSign,
    expedientTemplateId,
    documentToSignName,
    userId,
    onCloseElectronicSignatureModal,
    templateData,
    reloadExpedientDetailsComponent,
    setReloadTemplatesData,
    onCloseTemplateModal,
    electronicNotificationState,
    setShowModalTiny,
    dataExpedient,
    emailTemplateId,
    setIsUsersAndPermissionsListModalShowing,
    setDocumentToAssign,
    transferState,
  });

  const handleSignTemplate = async () => {
    if (dateIsAccepted && templateData['ifexcerpt']) {
      const publication_date = new Date(templateData['publication_date']);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Validar que la fecha de publicación no sea pasada
      const publicationDateNormalized = new Date(publication_date);
      publicationDateNormalized.setHours(0, 0, 0, 0);

      if (
        publicationDateNormalized < today &&
        dataExpedient &&
        dataExpedient.kind_judgment_id !== 59 &&
        dataExpedient.matter !== 'Laboral'
      ) {
        setTemplateData({
          ...templateData,
          publication_date: '',
        });
        setDatePickerIsEnabled(true);
        setDateIsAccepted(false);
        setErrors({
          ...errors,
          publication_date: [
            'La fecha de publicación no puede ser una fecha pasada. Por favor seleccione una fecha válida.',
          ],
        });
        return;
      }

      const holidays = await holidayDates();
      const isPublicationDateValid =
        isWeekday(publication_date) &&
        !holidays.some((date) => publication_date.getTime() === date.getTime());

      if (
        !isPublicationDateValid &&
        dataExpedient &&
        dataExpedient.kind_judgment_id !== 59 &&
        dataExpedient.matter !== 'Laboral'
      ) {
        setTemplateData({
          ...templateData,
          publication_date: '',
        });
        setDatePickerIsEnabled(true);
        setDateIsAccepted(false);
        setErrors({
          ...errors,
          publication_date: [
            'La fecha de publicación debe ser un día hábil y no coincidir con un feriado.',
          ],
        });
        setHoliday([...holidays, publication_date]);
        return;
      }
      onSingTemplate();
      return;
    }

    onSingTemplate();
  };

  const footerModal = (
    <Button
      disabled={
        !isElectronicSignatureTableShowing || !dateIsAccepted || !templateData['publication_date']
      }
      variant="success"
      onClick={handleSignTemplate}
    >
      <i className="fas fa-user-edit"></i> Firmar
    </Button>
  );

  const bodyModal = (
    <>
      {isElectronicSignatureModalSowing && (
        <CredentialsModal
          isModalSowing={isElectronicSignatureModalSowing}
          onCloseModal={onCloseCredentialsModal}
          addElectronicSignatureHandle={onAddElectronicSignature}
          isMultipleSignature={isMultipleSignature}
          electronicSignatureSettings={electronicSignatureSettingsFirel}
          isOnlyOneSignaturePerUserActivated
        />
      )}
      <Button
        variant="success"
        onClick={() => setIsElectronicSignatureModalSowing(true)}
        className={'mb-3'}
        style={{ marginTop: '20px' }}
      >
        {isThereASignature ? 'Cambiar Firma' : 'Agregar Firma'}
      </Button>

      {isMultisignatureEnabled && (
        <section className="text-muted mt-3 mb-3">
          <ToggleButton
            name="ToggleButtonName"
            onChange={onToggleButtonClick}
            id="isMultipleSignatureToggleButtonTemplatePresaved"
            isCheckedControlled={isMultipleSignature}
          >
            Multifirma
          </ToggleButton>
          <div className="text-muted mt-1 mb-2" style={{ fontSize: '11.2px', lineHeight: '1.5' }}>
            Activa esta sección si deseas que el documento sea firmado por más de un usuario.
          </div>
        </section>
      )}

      {isElectronicSignatureTableShowing && (
        <>
          <p className="m-0">{isMultipleSignature ? 'Lista de Firmantes' : 'Firmante'}</p>
          <ElectronicSignatureTable
            electronicSignaturesList={electronicSignaturesList}
            singleElectronicSignature={singleElectronicSignature}
            isMultipleSignature={isMultipleSignature}
            onDelteElectronicSignatureById={onDelteElectronicSignatureById}
          />
        </>
      )}

      {(templateData['type'] === 'judgment' || templateData['type'] === 'agreement') &&
        templateData['ifexcerpt'] && (
          <Form.Group>
            <Form.Label>* Fecha de publicación a boletín:</Form.Label>
            <DatePicker
              renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) =>
                secondCustomHeaderDatePicker(
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled
                )
              }
              dateFormat="dd/MM/yyyy"
              locale="es"
              minDate={new Date()}
              filterDate={
                dataExpedient &&
                dataExpedient.kind_judgment_id === 59 &&
                dataExpedient.matter === 'Laboral'
                  ? undefined
                  : isWeekday
              }
              excludeDates={
                dataExpedient &&
                dataExpedient.kind_judgment_id === 59 &&
                dataExpedient.matter === 'Laboral'
                  ? undefined
                  : holiday
              }
              customInput={<CustomInputDate ref={firstInputDatePicker} />}
              selected={
                templateData['publication_date']
                  ? moment(templateData['publication_date']).toDate()
                  : ''
              }
              disabled={!datePickerIsEnabled}
              onChange={(date) => {
                setTemplateData({
                  ...templateData,
                  publication_date: date,
                });
                setErrors({
                  ...errors,
                  publication_date: [],
                });
                setDateIsAccepted(false);
              }}
            />
            {templateData['publication_date'] && (
              <>
                <p className="text-xs">
                  Elegiste el día: {moment(templateData['publication_date']).format('DD/MM/YYYY')}
                </p>
                {!dateIsAccepted && (
                  <div className="">
                    <p>¿Estás seguro de que deseas continuar?</p>
                    <span>
                      <button
                        type="button"
                        className="btn btn-xs btn-success ml-2"
                        onClick={() => {
                          setDateIsAccepted(true);
                        }}
                      >
                        Aceptar
                      </button>
                      <button
                        className="btn btn-xs btn-error ml-2"
                        type="button"
                        // onClick={() => {
                        //   setTemplateHere({
                        //     ...templateData,
                        //     publication_date: "",
                        //   });
                        //   setDateIsAccepted(false);
                        // }}
                      >
                        Cancelar
                      </button>
                    </span>
                  </div>
                )}
              </>
            )}
            {renderErrorsList(errors, 'publication_date')}
          </Form.Group>
        )}
    </>
  );

  return (
    <>
      {isNotificationModalShowing && (
        <NotifyEmailModal
          showModal={isNotificationModalShowing}
          expedientId={ExpedientId}
          handleOnCancel={onCloseNotifyEmailModal}
          onAcceptClick={(restOfArguments) => {
            onSingTemplate({ signTemplateFromNotificationModal: true, ...restOfArguments });
          }}
        />
      )}
      <ModalComponent
        header="Firmar Plantilla"
        body={bodyModal}
        footer={footerModal}
        show={isElectronicSignatureModalOpen}
        canClose={true}
        onHide={onCloseElectronicSignatureModal}
        scroll={true}
        dialogClassName="electronic-signature-template-modal"
      />
      <SimpleSignatureAlert
        isModalShowing={isSimpleSignatureAlertShowing}
        setIsModalShowing={setIsSimpleSignatureAlertShowing}
        onCancel={onCancelSimpleSignatureAlertClick}
        onContinue={onContinueSimpleSignatureAlertClick}
      />
    </>
  );
};

export default ElectronicSignatureTemplatesModal;
